import {ReactNode} from 'react'

interface InputHelpTextProps {
    error?: ReactNode
    helpText?: ReactNode
}
function InputHelpText({error, helpText}: InputHelpTextProps) {
    return (
        <>
            {error && <small className="text-danger-500 text-sm">{error}</small>}
            {helpText && !error && <small className="text-neutral-500 text-sm">{helpText}</small>}
        </>
    )
}

export {InputHelpText}
